import { Alert, Box, Grid, Paper, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import ActionButton from '../../../components/Buttons/ActionButton'
import StatusCard from '../../../components/Cards/StatusCard'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'
import WarningIcon from '@mui/icons-material/Warning'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import BuildIcon from '@mui/icons-material/Build'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import FeedbackIcon from '@mui/icons-material/Feedback'
import Vaccines from '@mui/icons-material/Vaccines'
import SchoolIcon from '@mui/icons-material/School'
import HailIcon from '@mui/icons-material/Hail'
import ApprovalIcon from '@mui/icons-material/Approval'
import PersonOffIcon from '@mui/icons-material/PersonOff'
import LocalPoliceIcon from '@mui/icons-material/LocalPolice'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import InventoryIcon from '@mui/icons-material/Inventory'
import RateReviewIcon from '@mui/icons-material/RateReview'
import LocationOffIcon from '@mui/icons-material/LocationOff'
import RuleIcon from '@mui/icons-material/Rule'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'
import CampaignIcon from '@mui/icons-material/Campaign'
import { EmployeeContext } from '../../admin/personnel/employeeSingle/employeeSingle'
import {
  CarRepair,
  LocalCarWash,
  SwapCalls,
  TimerOutlined,
} from '@mui/icons-material'

const TeamActions = ({ dashboardData }) => {
  const { employee } = useContext(EmployeeContext)
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="title3">Team Actions</Typography>
      </Grid>
      {dashboardData.pendingImagingRequests && (
        <StatusCard
          number={dashboardData.pendingImagingRequests}
          label="Imaging Approvals"
          icon={MonitorHeartIcon}
          url="/patient-records/imaging"
          contrast
          pulse
        />
      )}
      {dashboardData.safetyAlerts && (
        <StatusCard
          number={dashboardData.safetyAlerts}
          label="Safety Alerts"
          color={1}
          icon={WarningIcon}
          url="/safety-alerts"
        />
      )}
      {dashboardData.deepCleansOverdue && (
        <StatusCard
          number={dashboardData.deepCleansOverdue}
          label="Deep Cleans Overdue"
          color={12}
          icon={LocalCarWash}
          url="/cleaning-schedules"
        />
      )}
      {dashboardData.newIncidents && (
        <StatusCard
          number={dashboardData.newIncidents}
          label="New Incidents"
          color={2}
          icon={GppMaybeIcon}
          url="/incidents"
          chip={`${dashboardData.newIncidents} NEW`}
        />
      )}
      {dashboardData.newPTfeedback && (
        <StatusCard
          number={dashboardData.newPTfeedback}
          label="Patient Feedback"
          color={3}
          icon={FeedbackIcon}
          url="/feedback"
        />
      )}
      {dashboardData.newFTSUconcerns && (
        <StatusCard
          number={dashboardData.newFTSUconcerns}
          label="Speak up concerns"
          icon={CampaignIcon}
          url="/speak-up-concerns"
        />
      )}
      {dashboardData.epcrAuditsRequired && (
        <StatusCard
          number={dashboardData.epcrAuditsRequired}
          label="ePCRs Awaiting Audit"
          color={16}
          icon={RuleIcon}
          url="/patient-records/audits"
        />
      )}
      {dashboardData.shiftApplications && (
        <StatusCard
          number={dashboardData.shiftApplications}
          label="Shift Applications"
          color={4}
          icon={ApprovalIcon}
          url="/shift-applications"
        />
      )}
      {dashboardData.shiftSwapRequests && (
        <StatusCard
          number={dashboardData.shiftSwapRequests}
          label="Shift Swap Requests"
          color={7}
          icon={SwapCalls}
          url="/shift-swap-requests"
        />
      )}
      {dashboardData.uncoveredShifts && (
        <StatusCard
          number={dashboardData.uncoveredShifts}
          label="Uncovered Shifts"
          color={5}
          icon={PersonOffIcon}
          url="/global-roster"
        />
      )}
      {dashboardData.newDefects && (
        <StatusCard
          number={dashboardData.newDefects}
          label="New Defects"
          color={6}
          icon={BuildIcon}
          url="/defects"
          chip={dashboardData.newDefects && `${dashboardData.newDefects} NEW`}
        />
      )}
      {dashboardData.vehicleServicesOverdue ? (
        <StatusCard
          number={dashboardData.vehicleServicesOverdue}
          label="Services Overdue"
          color={11}
          icon={CarRepair}
          url="/fleet"
        />
      ) : (
        dashboardData.vehicleServicesDue30Days && (
          <StatusCard
            number={dashboardData.vehicleServicesDue30Days}
            label="Services Due Soon"
            color={12}
            icon={CarRepair}
            url="/fleet"
          />
        )
      )}
      {dashboardData.expiredMeds && (
        <StatusCard
          number={dashboardData.expiredMeds}
          label="Expired Medicines"
          color={8}
          icon={Vaccines}
          url="/medicines-management"
        />
      )}
      {dashboardData.pendingOverTimeClaims && (
        <StatusCard
          number={dashboardData.pendingOverTimeClaims}
          label="Overtime Claims"
          icon={TimerOutlined}
          url="/overtime-claims"
        />
      )}
      {!dashboardData.expiredMeds && dashboardData.medsExpiringThisMonth && (
        <StatusCard
          number={dashboardData.medsExpiringThisMonth}
          label="Expiring Medicines"
          color={9}
          icon={Vaccines}
          url="/medicines-management"
        />
      )}
      {dashboardData.makeReadyExpiredItems ? (
        <StatusCard
          number={dashboardData.makeReadyExpiredItems}
          label="Expired Items"
          color={8}
          icon={InventoryIcon}
          url="/make-ready-overview"
        />
      ) : (
        dashboardData.makeReadyExpiringSoonItems && (
          <StatusCard
            number={dashboardData.makeReadyExpiringSoonItems}
            label="Items Expiring"
            color={9}
            icon={InventoryIcon}
            url="/make-ready-overview"
          />
        )
      )}
      {dashboardData.openedDrugsBags && (
        <StatusCard
          number={dashboardData.openedDrugsBags}
          label="Open Drugs Bags"
          color={16}
          icon={LockOpenIcon}
          url="/medicines-management"
        />
      )}
      {dashboardData.drugAuditDiscrepancies && (
        <StatusCard
          number={dashboardData.drugAuditDiscrepancies}
          label="Audit Discrepancies"
          color={10}
          icon={Vaccines}
          url="/medicines-management/audits"
        />
      )}
      {dashboardData.pendingMandatoryTraining && (
        <StatusCard
          number={dashboardData.pendingMandatoryTraining}
          label="Mandatory Training"
          color={11}
          icon={SchoolIcon}
          url="/pending-mandatory-training"
        />
      )}
      {dashboardData.pendingAppraisals && (
        <StatusCard
          number={dashboardData.pendingAppraisals}
          label="Appraisals to Review"
          color={14}
          icon={RateReviewIcon}
          url="/appraisals/pending-review"
        />
      )}
      {dashboardData.newEmployeeApplications && (
        <StatusCard
          number={dashboardData.newEmployeeApplications}
          label="Pending Applications"
          color={12}
          icon={WorkHistoryIcon}
          url="/employees/applications"
        />
      )}
      {dashboardData.pendingContacts && (
        <StatusCard
          number={dashboardData.pendingContacts}
          label="Client Accounts"
          color={13}
          icon={HailIcon}
          url="/pending-client-accounts"
        />
      )}
      {dashboardData.usersWithoutBaseLocations && (
        <StatusCard
          number={dashboardData.usersWithoutBaseLocations}
          label="Users Without Base Locations"
          color={13}
          icon={LocationOffIcon}
          url="/employees"
        />
      )}
      {dashboardData.newHSIncidents && (
        <StatusCard
          number={dashboardData.newHSIncidents}
          label="H&S Incidents"
          color={14}
          icon={AssignmentLateIcon}
          url="/patient-report-forms?defaultview=newhsincidents"
        />
      )}
      {dashboardData.newSafeguarding && (
        <StatusCard
          number={dashboardData.newSafeguarding}
          label="Safeguarding"
          color={15}
          icon={LocalPoliceIcon}
          url="/patient-report-forms?defaultview=newsafeguardingconcerns"
        />
      )}
    </Grid>
  )
}

export default TeamActions
